import React, { useState } from "react";
import { Tooltip, OverlayTrigger } from "react-bootstrap";

function InfoBox({ content, children }) {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <div
      // style={{ display: "inline-block", width: "fit-content" }}
      onMouseOver={() => setShowTooltip(true)}
      onMouseOut={() => setShowTooltip(false)}
      onFocus={() => setShowTooltip(true)}
      onBlur={() => setShowTooltip(false)}
    >
      {content && content.length > 0 ? (
        <OverlayTrigger
          show={showTooltip}
          placement="right"
          overlay={<Tooltip>{content}</Tooltip>}
        >
          {children}
        </OverlayTrigger>
      ) : (
        children
      )}
    </div>
  );
}

export default InfoBox;
